const SoundAlert = (status) => {

    if (status === "success") {

      const audio = new Audio('/assets/sound1.mp3');
      audio.play().catch(error => {
        console.error("Playback failed:", error);
      });
      
    }else if (status === "error") {

      const audio = new Audio('/assets/sound2.mp3');
      audio.play().catch(error => {
        console.error("Playback failed:", error);
      });
    }else if (status === "notification") {

      const audio = new Audio('/assets/sound3.mp3');
      audio.play().catch(error => {
        console.error("Playback failed:", error);
      });
    }

  };

    export default SoundAlert;